import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-play",
  "use": "icon-play-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-play\"><path d=\"M310.197073 316.665756c0-25.350244 17.882537-35.765073 39.811122-23.377171l355.827512 201.203513c21.978537 12.412878 21.928585 32.618146 0 45.006048L350.008195 740.676683c-21.978537 12.437854-39.811122 1.998049-39.811122-23.352195V316.665756z\" p-id=\"2133\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol